import React, {ComponentProps} from 'react';

import classNames from 'classnames';

import {Price} from 'components/price/price';
import {PayOverTimeLocations} from 'constants/payOverTime';
import {PayOverTime} from 'desktop/features/payOverTime/payOverTime';

import {RebateOffer} from '../rebateOffer/rebateOffer';
import {RebateTotal} from '../rebateTotal/rebateTotal';

import s from './rebateGrandTotal.scss';

type PropsType = {
    className?: string;
    totalRebateDiscount: number;
    totalWithRebate: number;
    price: number;
    title: React.ReactElement | string;
    size?: 'default' | 'large';
    eventName: ComponentProps<typeof RebateOffer>['eventName'];
};

/**
 * Display grand total value, klarna popup and rebate total
 * @returns {RebateGrandTotal} - component
 */
export const RebateGrandTotal: React.FC<PropsType> = ({
    className = '',
    eventName,
    price,
    size = 'default',
    title,
    totalRebateDiscount,
    totalWithRebate,
}) => (
    <div className={className}>
        <div
            className={classNames(s.grandTotalWrap, {
                [s.grandTotalWrapLarge]: size === 'large',
            })}
        >
            <div className={s.grandTotalRow}>
                <span className={s.label}>{title}:</span>
                <span className={s.totalPriceRebate}>
                    <Price>{price}</Price>
                </span>
            </div>
            <PayOverTime
                location={
                    eventName === 'checkoutReview'
                        ? PayOverTimeLocations.CHECKOUT_REBATE
                        : PayOverTimeLocations.CART_REBATE
                }
            />
        </div>
        <RebateTotal
            currentRebateDiscount={totalRebateDiscount}
            eventName={eventName}
            rebateTotalPrice={totalWithRebate}
        />
    </div>
);
